import { render, staticRenderFns } from "./Strategy.vue?vue&type=template&id=af952de0&scoped=true&"
import script from "./Strategy.vue?vue&type=script&lang=js&"
export * from "./Strategy.vue?vue&type=script&lang=js&"
import style0 from "./Strategy.vue?vue&type=style&index=0&id=af952de0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af952de0",
  null
  
)

export default component.exports